


























































































































































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import Input from '../../core/components/Input.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import VehiclesActions from './VehiclesActions.vue'
import { CompanyListItem, CompanyDetail, postCompanyResponse, postNewCompany, patchCompany, patchCompanyResponse } from '../models/Companies';
import { CompaniesService } from '../api/CompaniesService';
import { phoneValidator, rutValidation } from '../../core/utils/validations';
import { booleanFormatter, EventBus, getAlertColorByPriority, getIndexFromList, ID, matchedIndexIdInArray, TypeEventBus } from '../../core/utils';
import { User } from '../../user/models/Users';
import UserList from '../../user/components/UserList.vue';
import ConfigureJourneysModules from './ConfigureJourneysModules.vue';
import ConfigureGuardianModule from './ConfigureGuardianModule.vue';
import ModalInsuranceCompany from '../../insurance/components/ModalInsuranceCompany.vue'
import { InsuranceServices } from '../../insurance/api/InsuranceServices';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';

@Component({
    components: {
        Loading,
        Button,
        SectionTitle,
        Input,
        ConfigureJourneysModules,
        ConfigureGuardianModule,
        ModalInsuranceCompany,
        DeleteConfirmation
    }
})
export default class CompanyModules extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: null}) companyData: CompanyDetail;
    patchInsuranceCompany: object = {};
    idToPreselect: number = -1;
    stateText: string = 'Estado:';
    peritajeState: string = 'Es aseguradora:';
    journeyServiceText: string = 'Sistema de Jornales';
    guardianServiceText: string = 'Sistema El Guardián';
    peritajeServiceText: string = 'Sistema de Peritaje';
    activePeritajeText: string = 'Peritaje agrícola'
    activeText: string = 'Activo';
    inactiveText: string = 'Inactivo';
    hasActiveMDP: boolean = false;
    hasActiveJourney: boolean = false;
    hasActiveGuardian: boolean = false;
    hasPeritajeActive: boolean = false;
    visibleModalInsuranceCompany: boolean = false;
    editInsuranceCompany: boolean = false;
    loadingEditInsuranceCompany: boolean = false;
    visibleModalActivateJourneys: boolean = false;
    companyId: number = -1;
    visibleModalConfigureJourneys: boolean = false;
    visibleModalConfigureGuardian: boolean = false;

    //delete modal
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    pendingRequestInsuranceFarming: boolean = false;

    @Emit()
    updateInsuranceKey(value){
       
    }

    newCompanyCreated(newCompany){
        this.updateInsuranceKey(true);
    }

    @Emit()
    removeInsuranceService(){}

    visibilityModalConfigureJourneys(value){
        this.visibleModalConfigureJourneys = value;
    }

    visibilityModalInsuranceCompany(value){
        this.visibleModalInsuranceCompany = value;
    }
    showLoadingDialog(msg) {
        this.$_showLoadingDialog(msg);
    }

    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    visibilityModalConfigureGuardian(value: boolean){
        this.visibleModalConfigureGuardian = value;
    }

    removeInsuranceCompanyFromProperties(insuranceCompanyId) {
        let updatedProperties = JSON.parse(JSON.stringify(this.$_getInsuranceProperties));
        let updatedInsuranceCompanies = updatedProperties['insurance_companies'];
        let updatedInsuranceFarmings = updatedProperties['insurance_farmings'];
        let indexCompanyToRemove = matchedIndexIdInArray(updatedInsuranceCompanies, insuranceCompanyId);
        let farmingsToRemove = updatedInsuranceFarmings.filter(item => item['insurance_company'] == insuranceCompanyId);
        this.$_setInsuranceProperties([]);
        if (indexCompanyToRemove !== -1) {
            //remuevo la insurance company from properties insurance_companies list
            updatedInsuranceCompanies.splice(indexCompanyToRemove, 1);
        }
        //quito las insurance_farming de la empresa aseguradora eliminada
        for (let index = 0; index < farmingsToRemove.length; index++) {
            const insuranceFarming = farmingsToRemove[index];
            let indexInInsuranceFarmingList = matchedIndexIdInArray(updatedInsuranceFarmings, insuranceFarming['id']);

            if (indexInInsuranceFarmingList !== -1) {
                updatedInsuranceFarmings.splice(indexInInsuranceFarmingList, 1);
            }
        }
        this.$_setInsuranceProperties(updatedProperties);
    }

    getInsuranceIdFromProperties(){
        let indexInProperties =  this.$_getInsuranceProperties['insurance_companies'].findIndex(item => item['company'] == this.companyData.id);
        if(indexInProperties !== -1){
            return this.$_getInsuranceProperties['insurance_companies'][indexInProperties]['id'];
        }
        return -1
    }

    deleteAction(value) {
        let idToRemove = this.getInsuranceIdFromProperties();
        if (value) {
            this.confirmationDelete = false;
            this.showLoadingDialog('Eliminando Empresa Aseguradora');

            InsuranceServices.deleteInsuranceCompany(idToRemove)
                .then(response => {
                    this.showSuccessLoadingDialog(response.data, 'Empresa aseguradora eliminada con éxito');
                    this.removeInsuranceCompanyFromProperties(idToRemove);
                    this.removeInsuranceService();
                    this.setHasActivePeritaje(false);
                    this.updateInsuranceKey(false);
                })
                .catch(err => {
                    this.showCatchLoadingDialog(err, 'Ocurrio un error');
                });
        } else {
            this.confirmationDelete = false;
        }
    }

    btnDeleteInsuranceCompany(){
        this.deleteModalTitle = 'Eliminar Empresa Aseguradora';
        this.deleteBody =
            '¿Está seguro que desea eliminar la Empresa Aseguradora ' +
            '<b>"' +
            this.companyData['name'] +
            '"</b>?';
        this.confirmationDelete = true;
    }

    clickEditInsuranceCompany(){
        let idToUpdate = this.getInsuranceIdFromProperties();
        this.loadingEditInsuranceCompany = true;
        InsuranceServices.getInsuranceCompany(idToUpdate)
        .then(res => {
            this.patchInsuranceCompany = res;
            this.editInsuranceCompany = true;
            this.loadingEditInsuranceCompany = false;
            this.visibilityModalInsuranceCompany(true);
        })
        .catch(err => {
            this.loadingEditInsuranceCompany = false;
        });
    }

    get getJourneyState(){
        return this.hasActiveJourney ? this.activeText : this.inactiveText
    }

    get getGuardianState(){
        return this.hasActiveGuardian ? this.activeText : this.inactiveText
    }



    get getPeritajeTitle(){
        return this.hasPeritajeActive ? this.activePeritajeText : this.peritajeServiceText
    }
    get getPeritajeState(){
        return this.actualCompanyIsInsurance ? booleanFormatter(true) : booleanFormatter(false) 
    }

    get actualCompanyIsInsurance(){
        if(this.companyData !== null && this.companyData['is_insurance']){
            return true
        }
        return false
    }

    @Watch('companyData')
    observableCompanyData(){
        this.updateFields();
    }

    mounted(){
        this.updateFields();
    }

    setMDPInfo(value: CompanyDetail["mdp"]){
        this.companyData.mdp = value;
        this.hasActiveMDP = value.is_active;
    }
    
    setGuardianCredentials(guardianObj: CompanyDetail["guardian"]){
        this.$set(this.companyData, 'guardian', guardianObj);
        this.hasActiveGuardian = guardianObj.is_active;
    }
    
    


    updateFields() {
        this.setMDPInfo(this.companyData.mdp);
        this.setHasActiveGuardian(this.companyData.guardian);
        this.setHasActiveJourney(this.companyData.has_journey_active);
        this.setHasActivePeritaje(this.companyData.has_peritaje_active);
        this.companyId = this.companyData.id;
    }

    createInsuranceCompany(){
        this.editInsuranceCompany = false;
        this.idToPreselect = this.companyData['id']
        this.visibilityModalInsuranceCompany(true)
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    setHasActiveGuardian(guardianObj: CompanyDetail["guardian"]){
        this.hasActiveGuardian = guardianObj['is_active'];
        this.updateCompanyServicesInList();
    }

    setHasActiveJourney(value){
        this.hasActiveJourney = value;
        this.updateCompanyServicesInList();
    }
    setHasActivePeritaje(value){
        this.hasPeritajeActive = value;
        this.updateCompanyServicesInList();
    }

    updateCompanyServicesInList(){
        let self = this;
        EventBus.$emit(TypeEventBus.UPDATE_COMPANY_JOURNEY_SERVICES, {
            company_id: self.companyId,
            has_active_journey: self.hasActiveJourney,
            has_peritaje_active: self.hasPeritajeActive,
            has_active_guardian: self.hasActiveGuardian
        });
    }
}
